import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3150, { U3150ROLES } from './U3150';
import U3150TaskList from './components/U3150TaskList';
import U3150TaskForm from './components/U3150TaskForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3150Routes: RouteObject[] = [
  {
    path: 'U3150',
    element: <U2000RequireRole allowedRoles={[U3150ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3150 />,
        children: [
          { index: true, element: <U3150TaskList /> },
          { path: ':id', element: <U3150TaskForm /> },
        ],
      },
    ],
  },
];

export default U3150Routes;
